import 'svelte/internal/disclose-version';

SetPicker[$.FILENAME] = 'src/ui/SetPicker.svelte';

import * as $ from 'svelte/internal/client';
import { untrack } from "svelte";
import { Press, watchAlt } from "./keys.ts";
import { idleText, nextText, rowLabel } from "./picker.ts";
import { setPath } from "./route.ts";

var root = $.add_locations(
	$.from_html(
		`
    <header class="svelte-39wj2d19zjf5n">
      <p class="keymap svelte-39wj2d19zjf5n">
        <kbd class="svelte-39wj2d19zjf5n">j</kbd> <kbd class="svelte-39wj2d19zjf5n">k</kbd> or arrows move, <kbd class="svelte-39wj2d19zjf5n">1</kbd>–<kbd class="svelte-39wj2d19zjf5n"> </kbd> jump, <kbd class="svelte-39wj2d19zjf5n">Enter</kbd> starts
      </p>
    </header>
  `,
		1
	),
	SetPicker[$.FILENAME],
	[
		[
			118,
			4,
			[
				[
					119,
					6,
					[[120, 8], [120, 21], [120, 50], [120, 63], [120, 107]]
				]
			]
		]
	]
);

var root_1 = $.add_locations($.from_html(`<kbd class="svelte-39wj2d19zjf5n"> </kbd>`), SetPicker[$.FILENAME], [[148, 74]]);
var root_2 = $.add_locations($.from_html(`<span class="sep svelte-39wj2d19zjf5n"></span>`), SetPicker[$.FILENAME], [[149, 96]]);
var root_3 = $.add_locations($.from_html(`<span><!><span><span class="num svelte-39wj2d19zjf5n"> </span> <span class="term svelte-39wj2d19zjf5n"> </span></span></span>`), SetPicker[$.FILENAME], [[149, 64, [[149, 138, [[149, 225], [149, 265]]]]]]);
var root_4 = $.add_locations($.from_html(`<span class="item next svelte-39wj2d19zjf5n"><span class="sep svelte-39wj2d19zjf5n"></span><span> </span></span>`), SetPicker[$.FILENAME], [[149, 549, [[149, 573], [149, 610]]]]);
var root_5 = $.add_locations($.from_html(`<kbd class="svelte-39wj2d19zjf5n">Enter</kbd>`), SetPicker[$.FILENAME], [[154, 68]]);

var root_6 = $.add_locations(
	$.from_html(
		`
                <span class="pill svelte-39wj2d19zjf5n">Start <!></span>
              `,
		1
	),
	SetPicker[$.FILENAME],
	[[154, 16]]
);

var root_7 = $.add_locations(
	$.from_html(
		`
                <span> </span>
              `,
		1
	),
	SetPicker[$.FILENAME],
	[[156, 16]]
);

var root_8 = $.add_locations(
	$.from_html(
		`
        <li class="svelte-39wj2d19zjf5n">
          <a>
            <span class="name svelte-39wj2d19zjf5n"><span class="svelte-39wj2d19zjf5n"> </span><!></span>
            <span class="caption svelte-39wj2d19zjf5n"><!><span class="item lvl svelte-39wj2d19zjf5n"><span class="sep svelte-39wj2d19zjf5n"></span><span class="count svelte-39wj2d19zjf5n"><span class="term svelte-39wj2d19zjf5n">level</span> <span class="of svelte-39wj2d19zjf5n"> </span></span></span><!></span>
            <span class="n level svelte-39wj2d19zjf5n"> <span class="of svelte-39wj2d19zjf5n"> </span></span>
            <span class="n cards svelte-39wj2d19zjf5n"> </span>
            <span class="action svelte-39wj2d19zjf5n">
              <!>
            </span>
          </a>
        </li>
      `,
		1
	),
	SetPicker[$.FILENAME],
	[
		[
			135,
			8,
			[
				[
					136,
					10,
					[
						[148, 12, [[148, 31]]],
						[
							149,
							12,
							[
								[149, 335, [[149, 358], [149, 395, [[149, 415], [149, 481]]]]]
							]
						],
						[150, 12, [[150, 45]]],
						[151, 12],
						[152, 12]
					]
				]
			]
		]
	]
);

var root_9 = $.add_locations(
	$.from_html(
		`
    <div class="cols svelte-39wj2d19zjf5n" aria-hidden="true">
      <span class="svelte-39wj2d19zjf5n"></span>
      <span class="svelte-39wj2d19zjf5n"><span class="term svelte-39wj2d19zjf5n">Level</span></span>
      <span class="svelte-39wj2d19zjf5n">Cards</span>
      <span class="svelte-39wj2d19zjf5n"></span>
    </div>

    <ul class="svelte-39wj2d19zjf5n">
      <!>
    </ul>
  `,
		1
	),
	SetPicker[$.FILENAME],
	[
		[
			126,
			4,
			[[127, 6], [128, 6, [[128, 12]]], [129, 6], [130, 6]]
		],
		[133, 4]
	]
);

var root_10 = $.add_locations(
	$.from_html(
		`
    <p class="empty svelte-39wj2d19zjf5n">No sets yet. Run <code class="svelte-39wj2d19zjf5n">bun run db:import:hsk</code> for the HSK sets, or <code class="svelte-39wj2d19zjf5n">bun run db:import your-set.csv</code> for your own, then reload.</p>
  `,
		1
	),
	SetPicker[$.FILENAME],
	[[164, 4, [[164, 38], [164, 94]]]]
);

var root_11 = $.add_locations(
	$.from_html(
		`

<section class="picker svelte-39wj2d19zjf5n" aria-label="Sets">
  <!>

  <!>
</section>

`,
		1
	),
	SetPicker[$.FILENAME],
	[[116, 0]]
);

export default function SetPicker($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, SetPicker);

	let focus = $.prop($$props, 'focus', 3, null);
	let active = $.tag($.state($.proxy(untrack(() => Math.max(0, $$props.sets.findIndex((s) => $.strict_equals(s.id, focus())))))), 'active');
	let pressed = $.tag($.state(false), 'pressed');
	let hints = $.tag($.state(false), 'hints');
	let bouncing = $.tag($.state(null), 'bouncing');
	let rows = $.tag_proxy($.proxy([]), 'rows');
	const press = new Press();

	const tips = {
		level: "Where you are in the set's order: the level of the next new card, out of the set's highest level",
		due: "Cards whose review time has arrived",
		lessons: "New cards waiting to be learned",
		mature: "Cards you know well: in review with a memory stability of 21 days or more, Anki's threshold for a mature card"
	};

	const counts = ["due", "lessons", "mature"];

	$.user_effect(() => watchAlt((held) => $.set(hints, held, true)));

	$.user_effect(() => {
		rows[Math.min($.get(active), $$props.sets.length - 1)]?.focus();
	});

	function move(i) {
		const next = Math.max(0, Math.min($$props.sets.length - 1, i));

		if ($.strict_equals(next, $.get(active), false)) {
			press.cancel();
			$.set(pressed, false);
		}

		$.set(active, next, true);
		rows[next]?.focus();
	}

	function onkeydown(e) {
		if (e.metaKey || e.ctrlKey || e.altKey || !$$props.sets.length || e.defaultPrevented) return;
		if (e.target instanceof HTMLElement && e.target.closest("input, textarea, select, [contenteditable], dialog, button:not(.row)")) return;

		switch (e.key) {
			case "ArrowDown":

			case "j":
				move($.get(active) + 1);
				break;

			case "ArrowUp":

			case "k":
				move($.get(active) - 1);
				break;

			case "Home":
				move(0);
				break;

			case "End":
				move($$props.sets.length - 1);
				break;

			case "Enter":

			case " ":
				if (press.down(e.key, e.repeat, $.get(active))) $.set(pressed, !!$$props.sets[$.get(active)]?.queued);
				break;

			default:
				if (!(/^[1-9]$/).test(e.key) || Number(e.key) > $$props.sets.length) return;
				move(Number(e.key) - 1);
		}

		e.preventDefault();
	}

	function onkeyup(e) {
		const i = press.up(e.key);

		if ($.strict_equals(i, null)) return;

		e.preventDefault();
		$.set(pressed, false);

		const set = $$props.sets[i];

		if (set) activate(set);
	}

	$.user_effect(() => {
		const cancel = () => {
			press.cancel();
			$.set(pressed, false);
		};

		addEventListener("blur", cancel);
		addEventListener("keydown", onkeydown);
		addEventListener("keyup", onkeyup);

		return () => {
			removeEventListener("blur", cancel);
			removeEventListener("keydown", onkeydown);
			removeEventListener("keyup", onkeyup);
		};
	});

	function activate(set) {
		if (set.queued) $$props.onstart(set.id); else $.set(bouncing, set.id, true);
	}

	// Modified and middle clicks open the permalink as the browser would.
	function onclick(e, set) {
		if ($.strict_equals(e.button, 0, false) || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

		e.preventDefault();
		activate(set);
	}

	var $$exports = { ...$.legacy_api() };

	$.next();

	var fragment = root_11();
	var section = $.sibling($.first_child(fragment));
	var node = $.sibling($.child(section));

	{
		var consequent = ($$anchor) => {
			var fragment_1 = root();
			var header = $.sibling($.first_child(fragment_1));
			var p = $.sibling($.child(header));
			var kbd = $.sibling($.child(p), 7);
			var text = $.only_child(kbd, true);

			$.next(3);
			$.reset(p);
			$.next();
			$.reset(header);
			$.next();
			$.template_effect(($0) => $.set_text(text, $0), [() => Math.min(9, $$props.sets.length)]);
			$.append($$anchor, fragment_1);
		};

		$.add_svelte_meta(
			() => $.if(node, ($$render) => {
				if ($$props.sets.length && $.get(hints)) $$render(consequent);
			}),
			'if',
			SetPicker,
			117,
			2
		);
	}

	var node_1 = $.sibling(node, 2);

	{
		var consequent_6 = ($$anchor) => {
			var fragment_2 = root_9();
			var div = $.sibling($.first_child(fragment_2));
			var span = $.sibling($.child(div), 3);
			var span_1 = $.only_child(span);

			$.next(5);
			$.reset(div);

			var ul = $.sibling(div, 2);
			var node_2 = $.sibling($.child(ul));

			$.add_svelte_meta(
				() => $.each(node_2, 19, () => $$props.sets, (set) => set.id, ($$anchor, set, i) => {
					$.next();

					var fragment_3 = root_8();
					var li = $.sibling($.first_child(fragment_3));
					var a = $.sibling($.child(li));
					let classes;
					var span_2 = $.sibling($.child(a));
					var span_3 = $.child(span_2);
					var text_1 = $.only_child(span_3, true);
					var node_3 = $.sibling(span_3);

					{
						var consequent_1 = ($$anchor) => {
							var kbd_1 = root_1();
							var text_2 = $.only_child(kbd_1, true);

							$.template_effect(() => $.set_text(text_2, $.get(i) + 1));
							$.append($$anchor, kbd_1);
						};

						$.add_svelte_meta(
							() => $.if(node_3, ($$render) => {
								if ($.get(hints) && $.get(i) < 9) $$render(consequent_1);
							}),
							'if',
							SetPicker,
							148,
							54
						);
					}

					$.reset(span_2);

					var span_4 = $.sibling(span_2, 2);
					var node_4 = $.child(span_4);

					$.add_svelte_meta(
						() => $.each(node_4, 18, () => counts, (key) => key, ($$anchor, key, k) => {
							var span_5 = root_3();
							var node_5 = $.child(span_5);

							{
								var consequent_2 = ($$anchor) => {
									var span_6 = root_2();

									span_6.textContent = ' • ';
									$.append($$anchor, span_6);
								};

								$.add_svelte_meta(
									() => $.if(node_5, ($$render) => {
										if ($.get(k)) $$render(consequent_2);
									}),
									'if',
									SetPicker,
									149,
									89
								);
							}

							var span_7 = $.sibling(node_5);
							let classes_1;
							var span_8 = $.child(span_7);
							var text_3 = $.only_child(span_8, true);
							var text_4 = $.sibling(span_8, 1, true);

							text_4.nodeValue = ' ';

							var span_9 = $.sibling(text_4);
							var text_5 = $.only_child(span_9, true);

							$.reset(span_7);
							$.reset(span_5);

							$.template_effect(() => {
								$.set_class(span_5, 1, `item ${key ?? ''}`, 'svelte-39wj2d19zjf5n');

								classes_1 = $.set_class(span_7, 1, 'count svelte-39wj2d19zjf5n', null, classes_1, {
									zero: !$.get(set)[key],
									strong: $.strict_equals(key, "mature", false) && $.get(set)[key]
								});

								$.set_text(text_3, $.get(set)[key]);
								$.set_attribute(span_9, 'title', tips[key]);
								$.set_text(text_5, key);
							});

							$.append($$anchor, span_5);
						}),
						'each',
						SetPicker,
						149,
						34
					);

					var span_10 = $.sibling(node_4);
					var span_11 = $.child(span_10);

					span_11.textContent = ' • ';

					var span_12 = $.sibling(span_11);
					var span_13 = $.child(span_12);
					var text_6 = $.sibling(span_13);
					var span_14 = $.sibling(text_6);
					var text_7 = $.only_child(span_14);

					$.reset(span_12);
					$.reset(span_10);

					var node_6 = $.sibling(span_10);

					{
						var consequent_3 = ($$anchor) => {
							var span_15 = root_4();
							var span_16 = $.child(span_15);

							span_16.textContent = ' • ';

							var span_17 = $.sibling(span_16);
							let classes_2;
							var text_8 = $.only_child(span_17, true);

							$.reset(span_15);

							$.template_effect(
								($0) => {
									classes_2 = $.set_class(span_17, 1, 'when svelte-39wj2d19zjf5n', null, classes_2, { bounce: $.strict_equals($.get(bouncing), $.get(set).id) });
									$.set_text(text_8, $0);
								},
								[() => idleText($.get(set), $$props.now)]
							);

							$.event('animationend', span_17, function animationend() {
								return $.set(bouncing, null);
							});

							$.append($$anchor, span_15);
						};

						$.add_svelte_meta(
							() => $.if(node_6, ($$render) => {
								if (!$.get(set).queued) $$render(consequent_3);
							}),
							'if',
							SetPicker,
							149,
							532
						);
					}

					$.reset(span_4);

					var span_18 = $.sibling(span_4, 2);
					var text_9 = $.child(span_18, true);
					var span_19 = $.sibling(text_9);
					var text_10 = $.only_child(span_19);

					$.reset(span_18);

					var span_20 = $.sibling(span_18, 2);
					var text_11 = $.only_child(span_20, true);
					var span_21 = $.sibling(span_20, 2);
					var node_7 = $.sibling($.child(span_21));

					{
						var consequent_5 = ($$anchor) => {
							var fragment_4 = root_6();
							var span_22 = $.sibling($.first_child(fragment_4));
							var node_8 = $.sibling($.child(span_22));

							{
								var consequent_4 = ($$anchor) => {
									var kbd_2 = root_5();

									$.append($$anchor, kbd_2);
								};

								$.add_svelte_meta(
									() => $.if(node_8, ($$render) => {
										if ($.get(hints) && $.strict_equals($.get(i), $.get(active))) $$render(consequent_4);
									}),
									'if',
									SetPicker,
									154,
									41
								);
							}

							$.reset(span_22);
							$.next();
							$.append($$anchor, fragment_4);
						};

						var alternate = ($$anchor) => {
							var fragment_5 = root_7();
							var span_23 = $.sibling($.first_child(fragment_5));
							let classes_3;
							var text_12 = $.only_child(span_23, true);

							$.next();

							$.template_effect(
								($0) => {
									classes_3 = $.set_class(span_23, 1, 'next when svelte-39wj2d19zjf5n', null, classes_3, { bounce: $.strict_equals($.get(bouncing), $.get(set).id) });
									$.set_text(text_12, $0);
								},
								[() => nextText($.get(set), $$props.now)]
							);

							$.event('animationend', span_23, function animationend_1() {
								return $.set(bouncing, null);
							});

							$.append($$anchor, fragment_5);
						};

						$.add_svelte_meta(
							() => $.if(node_7, ($$render) => {
								if ($.get(set).queued) $$render(consequent_5); else $$render(alternate, -1);
							}),
							'if',
							SetPicker,
							153,
							14
						);
					}

					$.next();
					$.reset(span_21);
					$.next();
					$.reset(a);
					$.validate_binding('bind:this={rows[i]}', [], () => rows, () => $.get(i), 144, 12);
					$.bind_this(a, ($$value, i) => rows[i] = $$value, (i) => rows?.[i], () => [$.get(i)]);
					$.next();
					$.reset(li);
					$.next();

					$.template_effect(
						($0, $1) => {
							$.set_attribute(a, 'href', $0);

							classes = $.set_class(a, 1, 'row svelte-39wj2d19zjf5n', null, classes, {
								pressed: $.get(pressed) && $.strict_equals($.get(i), $.get(active)),
								idle: !$.get(set).queued
							});

							$.set_attribute(a, 'tabindex', $.strict_equals($.get(i), $.get(active)) ? 0 : -1);
							$.set_attribute(a, 'aria-disabled', $.get(set).queued ? undefined : "true");
							$.set_attribute(a, 'aria-label', $1);
							$.set_text(text_1, $.get(set).name);
							$.set_attribute(span_13, 'title', tips.level);
							$.set_text(text_6, ` ${$.get(set).level ?? ''}`);
							$.set_text(text_7, `/${$.get(set).levels ?? ''}`);
							$.set_text(text_9, $.get(set).level);
							$.set_text(text_10, `/${$.get(set).levels ?? ''}`);
							$.set_text(text_11, $.get(set).total);
						},
						[
							() => setPath($.get(set).slug),
							() => rowLabel($.get(set), $$props.now)
						]
					);

					$.event('focus', a, function focus_1() {
						return move($.get(i));
					});

					$.delegated('click', a, function click(e) {
						return onclick(e, $.get(set));
					});

					$.append($$anchor, fragment_3);
				}),
				'each',
				SetPicker,
				134,
				6
			);

			$.next();
			$.reset(ul);
			$.next();
			$.template_effect(() => $.set_attribute(span_1, 'title', tips.level));
			$.append($$anchor, fragment_2);
		};

		var alternate_1 = ($$anchor) => {
			var fragment_6 = root_10();

			$.next(2);
			$.append($$anchor, fragment_6);
		};

		$.add_svelte_meta(
			() => $.if(node_1, ($$render) => {
				if ($$props.sets.length) $$render(consequent_6); else $$render(alternate_1, -1);
			}),
			'if',
			SetPicker,
			125,
			2
		);
	}

	$.next();
	$.reset(section);
	$.next();
	$.append($$anchor, fragment);

	return $.pop($$exports);
}

$.delegate(['click']);
import "bun-svelte:SetPicker.svelte-2a5ypb1vgtntj-style.css";